import {pipelineHasStep} from 'analysis-tool/data/getStepFromAnalysis';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';

function isPipelineStepGraphQLInternallyConsistent(
  pipeline: PipelineGraphQL,
  step: PipelineGraphQL['execution']['steps'][number]
): boolean {
  return (
    step.definition.incomingEdges.every((edge) => pipelineHasStep(pipeline, edge.parent.step.id)) &&
    step.definition.outgoingEdges.every((edge) => pipelineHasStep(pipeline, edge.child.step.id))
  );
}

/**
 * Occasionally, if the pipeline is updated as the GraphQL query response is being generated on the backend,
 * the GraphQL response may be internally inconsistent, until the next re-fetch.
 *
 * Currently, Benchling's GraphQL endpoint does not guarantee internal consistency; to do so, it would have
 * to use (or expose an option for) REPEATABLE READ consistency.
 *
 * In particular, `GetAnalysisPipelineStep.definition.outgoingEdges` may reference steps that do not exist in
 * `AnalysisGraphQL.execution.steps`.
 *
 * To mitigate user impact while we investigate the underlying cause of these inconsistencies, we can
 * detect these inconsistencies on the front-end.
 *
 * @package
 */
export default function isPipelineGraphQLInternallyConsistent(pipeline: PipelineGraphQL): boolean {
  const isConsistent = pipeline.execution.steps.every((step) =>
    isPipelineStepGraphQLInternallyConsistent(pipeline, step)
  );
  return isConsistent;
}
